import { ResponseFormat } from './index.js'

/**
 * While the name is ridiculous, this interface defines the object that is
 * sometimes returned by the Congress API as the `request` property. It returns
 * some of the key properties that you sent in your initial request.
 */
export interface IResponseRequest {
  /** A catch-all key/value pair for any values that aren't pre-defined. */
  [key: string]: any

  /** The value of the content-type header. */
  contentType: string

  /** The value of the format query parameter. */
  format: ResponseFormat
}
